export type StatsVotesModelFR = {
  nbVotes: number;
  nbPromesses: number;
  noteMoyenne: number;
  pourcentPromessesSurVotants: number;
  noteProprieteIntellectuelle: number;
  noteProduitsServices: number;
  noteActionCommerciale: number;
  noteModeleEconomique: number;
  noteEntrepreneurEquipe: number;
  noteCoherenceFinanciere: number;
  noteMarche: number;
  noteClients: number;
  noteConcurrence: number;
  noteReglementation: number;
  noteRse: number;
};

export type StatsVotesModel = {
  nbVotes: number;
  nbPromises: number;
  meanScore: number;
  percentPromisesOverVoters: number;
  gradeIntellectualProperty: number;
  gradeProductsServices: number;
  businessActionRating: number;
  noteBusinessModel: number;
  noteEntrepreneurTeam: number;
  noteFinancialCherence: number;
  noteMarket: number;
  noteCustomers: number;
  noteCompetition: number;
  noteRegulation: number;
  noteRse: number;
};

export const translateStatsVotesModel = (sv: StatsVotesModelFR): StatsVotesModel => {
  return {
    nbVotes: sv.nbVotes,
    meanScore: sv.noteMoyenne,
    percentPromisesOverVoters: sv.pourcentPromessesSurVotants,
    nbPromises: sv.nbPromesses,
    gradeIntellectualProperty: sv.noteProprieteIntellectuelle,
    gradeProductsServices: sv.noteProduitsServices,
    businessActionRating: sv.noteActionCommerciale,
    noteBusinessModel: sv.noteModeleEconomique,
    noteEntrepreneurTeam: sv.noteEntrepreneurEquipe,
    noteFinancialCherence: sv.noteCoherenceFinanciere,
    noteMarket: sv.noteMarche,
    noteCustomers: sv.noteClients,
    noteCompetition: sv.noteConcurrence,
    noteRegulation: sv.noteReglementation,
    noteRse: sv.noteRse,
  };
};
